/* eslint-disable  babel/new-cap,react/destructuring-assignment,react/prop-types */
// Copyright (c) 2018 Deere & Company

import './index.scss';
import Container from './container';
import PropTypes from 'prop-types';
import React from 'react';

const DragAndDrop = (props) => (
    <Container
        id={props.containerId}
        list={props.availableItems}
        {...props}
    />
);

DragAndDrop.displayName = 'DragAndDrop';
DragAndDrop.propTypes = {
    availableItems: PropTypes.array.isRequired,
    idAttribute: PropTypes.string.isRequired,
    isDisplayValueMapped: PropTypes.bool.isRequired,
    mappingId: PropTypes.string,
    mappingTable: PropTypes.arrayOf(PropTypes.object),
    onCardMove: PropTypes.func.isRequired,
    onCardPush: PropTypes.func.isRequired,
    onCardRemove: PropTypes.func.isRequired,
    selectedItems: PropTypes.array.isRequired,
};

export default DragAndDrop;

/* eslint-enable babel/new-cap */
